export default __webpack_public_path__ + "static/media/ic_minus.f8bffea9.svg";